import { render } from "./ImageMask.vue?vue&type=template&id=487ddf64&scoped=true"
import script from "./ImageMask.vue?vue&type=script&lang=js"
export * from "./ImageMask.vue?vue&type=script&lang=js"

import "./ImageMask.vue?vue&type=style&index=0&id=487ddf64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487ddf64"]])

export default __exports__